export const generatedSourceRefreshReport = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "liveMode": false,
  "mode": "deterministic-source-refresh-evidence-report",
  "operatingRule": "Live source refreshes create review candidates only. Browser-facing beta data stays pinned to reviewed snapshots until hashes, units, uncertainty, license notes, and promotion tests pass.",
  "manifest": {
    "generatedAt": "2026-06-19T16:05:00Z",
    "mode": "deterministic-reviewed-snapshots",
    "rule": "The app may display these records without live API access, but refresh tools must preserve query, source, units, and tolerance metadata.",
    "sources": [
      "horizons-api",
      "sbdb-api",
      "cad-api",
      "spice-gf",
      "orekit",
      "gmat"
    ]
  },
  "snapshotCounts": {
    "horizons": 2,
    "sbdbCad": 2,
    "spiceGf": 1,
    "trajectoryContracts": 2
  },
  "snapshotHashes": {
    "horizons": "sha256-ba5518a8f6812b5e2ab01b0a6cc130641ac6a607403cba7875d0ccf34f3dad55",
    "sbdbCad": "sha256-960c71ef9382431f3e9a42368ee0cc75e3585ddbbe18506202d5c72f5607408b",
    "spiceGf": "sha256-564baae6edb1b40b387ab0e5472e70035d0745f85cdf7b93a5d5c956767f66de",
    "trajectoryContracts": "sha256-cd1900c0be8e17c8c364556621cfaccfe9ce791499bbd875b436d8d408be619b"
  },
  "refreshChecks": [
    {
      "id": "horizons-mercury-object-record",
      "sourceId": "horizons-api",
      "provider": "NASA/JPL Horizons",
      "url": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND='199'&OBJ_DATA='YES'&MAKE_EPHEM='NO'",
      "liveFetchSkipped": true,
      "reason": "Default beta refresh is snapshot-first. Use --live only to create reviewed refresh candidates; committed app data must remain deterministic.",
      "checkedAt": "2026-06-19T00:00:00.000Z",
      "requiredForPromotion": [
        "query echoed by provider",
        "time scale explicitly recorded",
        "distance/light-time fields mapped with units",
        "source response hash stored before claim promotion"
      ],
      "checkHash": "sha256-2c82ce643bd56236ea4cdd0eab829198b5bf7228d3df305de824d4479aa63fae"
    },
    {
      "id": "cad-2026-close-approach-screen",
      "sourceId": "cad-api",
      "provider": "NASA/JPL CNEOS CAD",
      "url": "https://ssd-api.jpl.nasa.gov/cad.api?dist-max=0.2&date-min=2026-01-01&date-max=2026-12-31",
      "liveFetchSkipped": true,
      "reason": "Default beta refresh is snapshot-first. Use --live only to create reviewed refresh candidates; committed app data must remain deterministic.",
      "checkedAt": "2026-06-19T00:00:00.000Z",
      "requiredForPromotion": [
        "cad fields captured with column metadata",
        "diameter and orbit uncertainty retained",
        "resource class remains unknown without taxonomy/spectra/mission evidence",
        "source response hash stored before candidate promotion"
      ],
      "checkHash": "sha256-0dca9b55489786422be1c50f70ec3daee3ad6cffdf73e01ced3e88a76f10e60f"
    }
  ],
  "promotionGates": [
    "source response hash exists",
    "license or terms note exists",
    "units are normalized",
    "uncertainty is retained or explicitly marked unknown",
    "query and capture timestamp are recorded",
    "tests compare generated outputs against pinned tolerances"
  ],
  "blockedClaims": [
    "SPICE event windows remain adapter fixtures until kernel hashes and generated run artifacts exist.",
    "Orekit/GMAT trajectory claims remain contracts until independent sidecar output is attached.",
    "Asteroid resource claims remain unknown unless taxonomy, spectra, or mission evidence is sourced."
  ],
  "reportHash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02"
}
;
